module.exports = __webpack_public_path__ + "img/book.6eb32d7f.png";